module.exports = __webpack_public_path__ + "static/media/sr_redesign.04b255ec.png";